import moment from 'moment';
import { stateConvert } from "web/components/utils/stateAbbreviation";

const getActualQuantityFunc = val => {
  let actualDisplayQuantity = val.orderDetails?.quantity
  let totalClaimQuantity = 0
  if (val.claimDetails?.length > 0) {
    totalClaimQuantity = val.claimDetails.reduce((acc, value) => {
      return acc + value.claimQuantity + value.claimQuality
    }, 0)
  }
  actualDisplayQuantity = actualDisplayQuantity - totalClaimQuantity
  return actualDisplayQuantity
}

export const setDelOrdersCsvFunction = (tempDataSorted) => {
  let tempCsvData = tempDataSorted.map((val) => {

    const wrapInQuotes = (value) => {
      if (!value) return '"NA"';
      return `"${value.toString().replace(/"/g, '""').replace(/\n/g, ' ').replace(/\r/g, ' ')}"`;
    };

    // for calculating the remaining quanity in case claim raised scenarios
    let actualDisplayQuantity = getActualQuantityFunc(val)

    //for deciding acc details (self)
    let accNumber = "";
    if (val.userType === "BUYER") {
      accNumber = `****${val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit ?
        val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit : val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.achBankAccount?.last4}`
    }
    if (val.userType === "SELLER") {
      if (val.sellerInfo.paymentMethodInfo.paymentMethodDetails.bankAccount)
        accNumber = `****${val.sellerInfo.paymentMethodInfo.paymentMethodDetails.bankAccount.last4}`;
      if (val.sellerInfo.paymentMethodInfo.paymentMethodDetails.card)
        accNumber = `****${val.sellerInfo.paymentMethodInfo.paymentMethodDetails.card.last4Digit}`;
    }
    let buyerFeetoPT = val.buyerInfo.price.productPrice * (val.buyerInfo.price.serviceChargePercent / 100)
    let stripeFee = ((val.buyerInfo.price.productPrice + val.buyerInfo.price.tax + buyerFeetoPT) * (val.stripeFeePercent / 100)) + 0.3
    let claimDetailsTemp
    if (val.claimDetails && val.claimDetails?.length > 0) {
      claimDetailsTemp = val.claimDetails.map(data => {
        return (
          (data.claimQuantity + data.claimQuality) + '-' + (data.issueType) + '-' + (data.status)
        )
      })
    }

    //Buyer-Seller Comments
    let buyerComments = "";
    let sellerComments = "";
    let orderComments = val?.comments;
    orderComments?.length > 0 && orderComments.forEach(item => {
      if (item.userType === "BUYER" && item.comment) {
        buyerComments += (buyerComments.length > 0 ? "-- " : "") + item.comment;
      } else if (item.userType === "SELLER" && item.comment) {
        sellerComments += (sellerComments.length > 0 ? "-- " : "") + item.comment;
      }
    });


    let mainOrderReturnObj = {
      OrderId: val.id?.replaceAll(",", " ")?.replaceAll("\n", " "),
      InvoiceNo: val?.invoiceNo ? val?.invoiceNo : "NA",
      InvoiceDate: val?.invoiceDate ? moment(val?.invoiceDate).format("MM-DD-YYYY") : "NA",
      PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ") : "",
      ReferenceNumber: val.userType === 'SELLER'
        ? val.referenceNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")
        : val.orderRefNumber?.replaceAll(",", " ")?.replaceAll("\n", " "),
      PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " "),
      TransportType:
        val.contactInfo?.type === "DELIVERABLE"
          ? "Delivery"
          : "Pickup",
      Material: val?.orderDetails?.material || 'NA',
      Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
      PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
      Moisture: val.orderDetails.moistureContent || 'NA',
      Size: val?.orderDetails?.grade?.gradeName || 'NA',
      Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
      Location: val.contactInfo?.address ?
        wrapInQuotes(`${val.contactInfo.address.line1}, ${val.contactInfo.address.city}, ${stateConvert(val.contactInfo.address.state) || val.contactInfo.address.state}, ${val.contactInfo.address.zip}`)
        : "NA",
      Role: val.userType === "BUYER" ? "Buyer" : "Seller",
      OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
      Status: val.orderStatus === 'CANCELLED' ? 'CANCELED' : val.orderStatus,
      ClaimDetails: claimDetailsTemp ? claimDetailsTemp.join(' & ') : 'NA',
      RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),

      PaymentUpdatedDate: val.orderStatus === "COMPLETE" ? moment(val.paymentStatusDetails?.created * 1000).format("MM-DD-YYYY") : 'NA',
      ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
      AcNo: accNumber,
      Quantity: actualDisplayQuantity,
      PayoutDate: (val.payoutDetails?.payoutStatus === 'SUCCESS' && val.payoutDetails?.updatedAt && val.userType === "SELLER") ? moment(val.payoutDetails?.updatedAt).format("MM-DD-YYYY") : 'NA',
      PayoutStatus: (val.payoutDetails?.payoutStatus === 'SUCCESS' && val.userType === "SELLER") ? val.payoutDetails?.status?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : 'NA',
      UnitPrice: `$ ${val.orderDetails?.pricePerPallet?.toFixed(2)}`,
      ExtendedAmount: `$ ${(val.buyerInfo?.price?.productPrice)?.toFixed(2)}`,
      BuyerDiscount: val.buyerInfo?.price?.buyerDiscountAmount != null ? `$ ${val.buyerInfo.price.buyerDiscountAmount}` : 'NA',
      BuyerDiscountedPrice: val.buyerInfo?.price?.productPriceAfterDiscount != null ? `$ ${val.buyerInfo.price.productPriceAfterDiscount}` : 'NA',
      SellerDiscount: val.sellerInfo?.price?.sellerDiscountAmount != null ? `$ ${val.sellerInfo.price.sellerDiscountAmount}` : 'NA',
      SellerDiscountedPrice: val.sellerInfo?.price?.productPriceAfterDiscount != null ? `$ ${val.sellerInfo.price.productPriceAfterDiscount}` : 'NA',
      PaymentTerm: val.sellerInfo?.price?.deliveryTerm != null ? `${val.sellerInfo.price.deliveryTerm} days` : 'NA',
      PaymentTermDiscount: val.sellerInfo?.price?.deliveryTermDiscount != null ? `${val.sellerInfo.price.deliveryTermDiscount.toFixed(1)} %` : 'NA',
      Tax: val.userType === "BUYER" ? `$ ${val.buyerInfo?.price?.tax?.toFixed(2)}` : 'NA',
      OtherFee: val.userType === "BUYER" ? `$ ${(val.buyerInfo.price.serviceCharge - val.buyerInfo.price.tax)?.toFixed(2)}` : `$ ${val.sellerInfo?.price?.serviceCharge?.toFixed(2) || 0}`,
      TotalAmount: val.userType === "BUYER" ? `$ ${val.buyerInfo?.price?.totalPrice?.toFixed(2)}` : `$ ${val.sellerInfo?.price?.totalPrice?.toFixed(2)}`,
      BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
    }
    let adjustedOrderReturnObj
    if (val.isAdjusted && val.fundAdjustment) {
      let toalPriceBuyer, totalPriceSeller, totalPricePTAdmin
      if (val.fundAdjustment?.adjustmentType === 'BUYER_AC') {
        toalPriceBuyer = `$ ${val.fundAdjustment?.adjPrice?.buyerTotalPrice}`
        totalPriceSeller = `$ ${val.fundAdjustment?.adjPrice?.sellerTotalPrice}`
        totalPricePTAdmin = 'NA'
      } else if (val.fundAdjustment?.adjustmentType === 'SELLER_AC') {
        toalPriceBuyer = `-$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = `-$ ${val.fundAdjustment?.adjPrice?.sellerDeductAmount}`
        totalPricePTAdmin = 'NA'
      } else if (val.fundAdjustment?.adjustmentType === 'PT_AC') {
        toalPriceBuyer = `-$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = `NA`
        totalPricePTAdmin = `-$ ${val.fundAdjustment?.adjPrice?.ptPaidAmount}`
      }
      let extendedAmountValue, totalFeeBuyerVal, totalFeeSellerVal, buyerTaxFee, buyerTaxFeeDiff, buyerStripeFee, buyerStripeFeeDiff, totalServiceFeeBuyer
      if (val.fundAdjustment?.adjustmentType === 'BUYER_AC') {
        extendedAmountValue = `$ ${(val.fundAdjustment?.adjPrice?.adjAmount)?.toFixed(2)}`
        let tempData = val.fundAdjustment?.adChargeDetails
        totalFeeBuyerVal = `$ ${tempData?.buyerPTFee?.toFixed(2) || 0}`
        totalFeeSellerVal = `$ ${tempData?.sellerPTFee?.toFixed(2) || 0}`
        buyerTaxFee = `$ ${tempData?.taxAmount?.toFixed(2)}`
        buyerTaxFeeDiff = `$ ${tempData?.adjTaxDiffAmount?.toFixed(2)}`
        buyerStripeFee = `$ ${tempData?.stripeFee?.toFixed(2)}`
        buyerStripeFeeDiff = `$ ${tempData?.adjStripeFeeDiffAmt?.toFixed(2)}`
        totalServiceFeeBuyer = `$ ${(tempData?.buyerPTFee + tempData?.stripeFee)?.toFixed(2)}`
      } else {
        extendedAmountValue = `-$ ${(val.fundAdjustment?.adjPrice?.adjAmount)?.toFixed(2)}`
        let tempData = val.fundAdjustment?.adjPrice?.priceDifference
        totalFeeBuyerVal = `-$ ${tempData?.buyerPTFeeDiff?.toFixed(2) || 0}`
        totalFeeSellerVal = `-$ ${tempData?.sellerPTFeeDiff?.toFixed(2) || 0}`
        buyerTaxFee = `-$ ${tempData?.taxDiff?.toFixed(2)}`
        buyerStripeFee = `-$ ${tempData?.stripeFeeDiff?.toFixed(2)}`
        buyerTaxFeeDiff = `-$ ${val.fundAdjustment?.adjPrice?.adjTaxDiffAmount?.toFixed(2)}`
        buyerStripeFeeDiff = `-$ ${val.fundAdjustment?.adjPrice?.adjStripeFeeDiffAmt?.toFixed(2)}`
        totalServiceFeeBuyer = `-$ ${(tempData?.buyerPTFeeDiff + tempData?.stripeFeeDiff)?.toFixed(2)}`
      }

      if (val.fundAdjustment?.adjustmentType === 'REFUND_TAX') {
        extendedAmountValue = '$ 0'
        buyerTaxFee = `-$ ${val.buyerInfo?.price?.tax?.toFixed(2)}`
        toalPriceBuyer = `$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = '$ 0'
        totalPricePTAdmin = `-$ ${val.fundAdjustment?.adjPrice?.ptPaidAmount}`
      }
      adjustedOrderReturnObj = {
        OrderId: val.fundAdjustment?.avaOrderId,
        InvoiceNo: val?.invoiceNo ? val?.invoiceNo : "NA",
        InvoiceDate: val?.invoiceDate ? moment(val?.invoiceDate).format("MM-DD-YYYY") : "NA",
        PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ") : "",
        ReferenceNumber: val.userType === 'SELLER'
          ? val.referenceNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")
          : val.orderRefNumber?.replaceAll(",", " ")?.replaceAll("\n", " "),
        PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " "),
        TransportType:
          val.contactInfo?.type === "DELIVERABLE"
            ? "Delivery"
            : "Pickup",
        Material: val?.orderDetails?.material || 'NA',
        Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
        PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
        Moisture: val.orderDetails.moistureContent || 'NA',
        Size: val?.orderDetails?.grade?.gradeName || 'NA',
        Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
        Location: val.contactInfo?.address ?
          wrapInQuotes(`${val.contactInfo.address.line1}, ${val.contactInfo.address.city}, ${stateConvert(val.contactInfo.address.state) || val.contactInfo.address.state}, ${val.contactInfo.address.zip}`)
          : "NA",
        Role: val.userType === "BUYER" ? "Buyer" : "Seller",
        OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
        Status: 'ADJUSTMENT',
        ClaimDetails: 'NA',
        RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),
        PaymentUpdatedDate: val.orderStatus === "COMPLETE" ? moment(val.paymentStatusDetails?.created * 1000).format("MM-DD-YYYY") : 'NA',
        ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
        AcNo: accNumber,
        Quantity: val.fundAdjustment?.adjustmentType === 'BUYER_AC' ? val.fundAdjustment?.adjPrice?.adjQty : `-${val.fundAdjustment?.adjPrice?.adjQty}`,
        PayoutDate: (val.payoutDetails?.payoutStatus === 'SUCCESS' && val.payoutDetails?.updatedAt && val.userType === "SELLER") ? moment(val.payoutDetails?.updatedAt).format("MM-DD-YYYY") : 'NA',
        PayoutStatus: (val.payoutDetails?.payoutStatus === 'SUCCESS' && val.userType === "SELLER") ? val.payoutDetails?.status?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : 'NA',
        UnitPrice: `$ ${val.orderDetails?.pricePerPallet?.toFixed(2)}`,
        ExtendedAmount: extendedAmountValue,
        BuyerDiscount: 'NA',
        BuyerDiscountedPrice: 'NA',
        SellerDiscount: 'NA',
        SellerDiscountedPrice: 'NA',
        PaymentTerm: 'NA',
        PaymentTermDiscount: 'NA',
        Tax: val.userType === "BUYER" ? buyerTaxFee : 'NA',
        OtherFee: val.userType === "BUYER" ? totalServiceFeeBuyer : totalFeeSellerVal,
        TotalAmount: val.userType === "BUYER" ? toalPriceBuyer : totalPriceSeller,
        BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
        SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      }
    }
    let promoCodeDetailsObj
    if (val.promoReport?.promoCode && val.userType === "BUYER") {
      promoCodeDetailsObj = {
        OrderId: `${val.promoReport?.orderId}-PROMO`,
        InvoiceNo: val?.promoInvoiceId ? val?.promoInvoiceId : "NA",
        InvoiceDate: val?.invoiceDate ? moment(val?.invoiceDate).format("MM-DD-YYYY") : "NA",
        PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ") : "",
        ReferenceNumber: val.userType === 'SELLER'
          ? val.referenceNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")
          : val.orderRefNumber?.replaceAll(",", " ")?.replaceAll("\n", " "),
        PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " "),
        TransportType:
          val.contactInfo?.type === "DELIVERABLE"
            ? "Delivery"
            : "Pickup",
        Material: val?.orderDetails?.material || 'NA',
        Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
        PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
        Moisture: val.orderDetails.moistureContent || 'NA',
        Size: val?.orderDetails?.grade?.gradeName || 'NA',
        Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
        Location: val.contactInfo?.address ?
          wrapInQuotes(`${val.contactInfo.address.line1}, ${val.contactInfo.address.city}, ${stateConvert(val.contactInfo.address.state) || val.contactInfo.address.state}, ${val.contactInfo.address.zip}`)
          : "NA",
        Role: val.userType === "BUYER" ? "Buyer" : "Seller",
        OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
        Status: val.orderStatus === 'CANCELLED' ? 'CANCELED' : val.orderStatus,
        ClaimDetails: 'NA',
        RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),

        PaymentUpdatedDate: val.orderStatus === "COMPLETE" ? moment(val.paymentStatusDetails?.created * 1000).format("MM-DD-YYYY") : 'NA',
        ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
        AcNo: accNumber,
        Quantity: 'NA',
        PayoutDate: 'NA',
        PayoutStatus: 'NA',
        UnitPrice: 'NA',
        ExtendedAmount: `-$ ${(val.promoReport?.discountAmount)?.toFixed(2)}`,
        BuyerDiscount: 'NA',
        BuyerDiscountedPrice: 'NA',
        SellerDiscount: 'NA',
        SellerDiscountedPrice: 'NA',
        PaymentTerm: 'NA',
        PaymentTermDiscount: 'NA',
        Tax: 'NA',
        OtherFee: 'NA',
        TotalAmount: 'NA',
        BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
        SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      }
    }
    if (adjustedOrderReturnObj && promoCodeDetailsObj) return ([mainOrderReturnObj, adjustedOrderReturnObj, promoCodeDetailsObj])
    else if (adjustedOrderReturnObj) return ([mainOrderReturnObj, adjustedOrderReturnObj])
    else if (promoCodeDetailsObj) return ([mainOrderReturnObj, promoCodeDetailsObj])
    else return (mainOrderReturnObj)
  });
  return tempCsvData.flat();
}

export const setPickupOrdersCsvFunction = (orderData) => {
  const finalCsvData = orderData.flatMap(item => {
    const baseData = {
      OrderNo: item?.orderId,
      InvoiceNo: item?.invoiceNo || 'NA',
      InvoiceDate: item?.invoiceDate || 'NA',
      PurchaseOrder: item?.poNumber,
      ReferenceNumber: item?.userType === 'SELLER' ? item?.ptplusRefNumber : 'NA',
      SupplierReferenceNumber: item?.supplierRefNumber || 'NA',
      Type: item?.type,
      PickupLocationDetails: item?.pickupLocationInfo?.replace(/,|\n|\r/g, " "),
      Status: item.orderStatus === 'CANCELLED' ? 'CANCELED' : item.orderStatus,
      ClaimDetails: item?.claimDetails || 'NA',
      ReqPickupDate: item?.requestPickupDate,
      ActualPickupDate: item?.actualPickupDate || 'NA',
      PaymentInitiatedDate: item?.initiatePaymentDate || 'NA',
      MyAcNo: item.cardInfo ? ('****' + item.cardInfo) : 'NA',
      ExtendedAmt: '$' + item?.extendedAmount?.toFixed(2),
      CollectionTerm: item?.buyerPaymentTerm != null ? `${item.buyerPaymentTerm} days` : 'NA',
      CollectionTermDiscount: item?.buyerTermDiscount != null ? `${item.buyerTermDiscount} %` : 'NA',
      BuyerDiscount: item.buyerDiscountAmount != null ? `$ ${item.buyerDiscountAmount}` : 'NA',
      Tax: item?.userType === 'SELLER' ? 'NA' : `$ ${item?.tax?.toFixed(2)}`,
      OtherFee: '$' + item?.otherFee?.toFixed(2),
      TotalAmt: '$' + item?.totalAmount?.toFixed(2),
      BuyerComment: item?.buyerComment?.replace(/,|\n|\r/g, " ") || 'NA',
      SellerComment: item?.sellerComment?.replace(/,|\n|\r/g, " ") || 'NA'
    };

    if (!item.palletDetails || item.palletDetails.length === 0) {
      return [{
        ...baseData,
        PalletType: 'NA',
        Quantity: 'NA',
        UnitPrice: 'NA',
        SubTotalAmt: 'NA',
      }];
    }

    return item.palletDetails.map(pallets => ({
      ...baseData,
      PalletType: pallets?.palletType,
      Quantity: pallets?.qty,
      UnitPrice: '$' + pallets?.vendorPrice?.toFixed(2),
      SubTotalAmt: '$' + pallets?.vendorSubtotal?.toFixed(2),
    }));
  });

  return finalCsvData;
};



